import { Theme } from '@/constants'
import { getTheme, setTheme as setLocalStorageTheme } from '@/services/localStorage'

export function useThemeUno() {
  const theme = ref<string>(getTheme())
  const preferredDark = usePreferredDark()

  const isDark = useDark({
    selector: 'html',
    attribute: 'class',
    valueDark: 'dark',
    valueLight: '',
  })
  const toggleDark = useToggle(isDark)

  const setTheme = (newTheme: string) => {
    theme.value = newTheme
    setLocalStorageTheme(newTheme)
    applyTheme()
  }

  const applyTheme = () => {
    if (theme.value === Theme.Dark) {
      toggleDark(true)
    }
    else if (theme.value === Theme.Light) {
      toggleDark(false)
    }
    else {
      toggleDark(preferredDark.value)
    }
  }

  const computedIsDark = computed(() =>
    theme.value === Theme.Dark || (preferredDark.value),
  )

  // Initial theme application
  applyTheme()

  return {
    theme,
    setTheme,
    isDark: computedIsDark,
  }
}
